function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnreadItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3410_1817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C6.19593 16 4.89199 16 3.84259 15.8593C2.66146 15.7008 1.86436 15.357 1.25258 14.7474C0.643037 14.1379 0.299191 13.3385 0.140664 12.1574C-2.12933e-08 11.108 0 9.80408 0 8C0 6.19593 -2.12933e-08 4.89199 0.140664 3.84259C0.299191 2.66146 0.643037 1.86436 1.25258 1.25258C1.86213 0.640804 2.66146 0.299191 3.84259 0.140664C4.89199 -2.12933e-08 6.19593 0 8 0H9.11638C9.42451 0 9.67457 0.25007 9.67457 0.558191C9.67457 0.866313 9.42451 1.11638 9.11638 1.11638H8C4.65085 1.11638 2.96958 1.11638 2.04298 2.04298C1.11638 2.96958 1.11638 4.65085 1.11638 8C1.11638 11.3491 1.11638 13.0304 2.04298 13.957C2.96958 14.8836 4.65085 14.8836 8 14.8836C11.3491 14.8836 13.0304 14.8836 13.957 13.957C14.8836 13.0304 14.8836 11.3491 14.8836 8V6.88362C14.8836 6.5755 15.1337 6.32543 15.4418 6.32543C15.7499 6.32543 16 6.5755 16 6.88362V8C16 9.80408 16 11.108 15.8593 12.1574C15.7008 13.3385 15.357 14.1356 14.7474 14.7474C14.1379 15.357 13.3385 15.7008 12.1574 15.8593C11.108 16 9.80408 16 8 16Z",
    fill: "#828282",
    style: {
      fill: "#828282",
      fill: "color(display-p3 0.5083 0.5083 0.5083)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.209 5.58191C11.6706 5.58191 10.418 4.32933 10.418 2.79096C10.418 1.25258 11.6706 0 13.209 0C14.7474 0 15.9999 1.25258 15.9999 2.79096C15.9999 4.32933 14.7496 5.58191 13.209 5.58191ZM13.209 1.11638C12.2846 1.11638 11.5344 1.86659 11.5344 2.79096C11.5344 3.71532 12.2846 4.46553 13.209 4.46553C14.1333 4.46553 14.8836 3.71532 14.8836 2.79096C14.8836 1.86659 14.1333 1.11638 13.209 1.11638ZM10.9762 10.0474H4.27792C3.9698 10.0474 3.71973 9.79738 3.71973 9.48925C3.71973 9.18113 3.9698 8.93106 4.27792 8.93106H10.9762C11.2843 8.93106 11.5344 9.18113 11.5344 9.48925C11.5344 9.79738 11.2843 10.0474 10.9762 10.0474ZM8.74345 12.6509H4.27792C3.9698 12.6509 3.71973 12.4008 3.71973 12.0927C3.71973 11.7845 3.9698 11.5345 4.27792 11.5345H8.74345C9.05157 11.5345 9.30164 11.7845 9.30164 12.0927C9.30164 12.4008 9.05157 12.6509 8.74345 12.6509Z",
    fill: "#828282",
    style: {
      fill: "#828282",
      fill: "color(display-p3 0.5083 0.5083 0.5083)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3410_1817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadItems);
export default __webpack_public_path__ + "static/media/unreadItems.3e7fe59f54ced1fe407e204afc9c2b08.svg";
export { ForwardRef as ReactComponent };